import { css, styled } from 'styled-components'
import { mqMin, space, tokPx } from '../../../utils'

type ModVariantType = 'fullWidth' | 'padded'

const Layout = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: ${tokPx('primitives_area_size_1440')};

  ${modVariant()}
`

export default Layout

function modFullWidth() {
  return css`
    padding: 0;
  `
}

function modPadded() {
  return css`
    padding-left: ${space('primitives_space_16')};
    padding-right: ${space('primitives_space_16')};

    @media ${mqMin('primitives_breakpoint_m_min')} {
      padding-left: ${space('primitives_space_32')};
      padding-right: ${space('primitives_space_32')};
    }

    @media ${mqMin('primitives_breakpoint_l_min')} {
      padding-left: ${space('primitives_space_48')};
      padding-right: ${space('primitives_space_48')};
    }
  `
}

export function modVariant(variant: ModVariantType = 'padded') {
  switch (variant) {
    case 'fullWidth':
      return modFullWidth()
    default:
      return modPadded()
  }
}
